import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../shared/services/common/common.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { UserDataService } from '../../../shared/services/user-data/user-data.service';
import { SimulateResultModel } from '../../models/simulate-result.model';
import { SimulatorService } from '../../services/simulator/simulator.service';

@Component({
  selector: 'app-pre-simulator',
  templateUrl: './pre-simulator.component.html',
  styleUrls: ['./pre-simulator.component.scss'],
  standalone: false,
})
export class PreSimulatorComponent implements OnInit {
  public showSimulation: boolean;
  public dataSimulate: SimulateResultModel;

  numChanges = 0;

  constructor(
    private _simulatorService: SimulatorService,
    private _commonService: CommonService,
    private userDataService: UserDataService,
    private gtm: GtmService,
  ) {}

  ngOnInit() {
    this.showSimulation = false;
    this.gtm.sendVarGTM({ pageType: 'Simulador' });
  }

  generateSimunation(dataSimulate: SimulateResultModel) {
    this.dataSimulate = dataSimulate;
    this.showSimulation = this.dataSimulate ? true : false;
  }

  resetSimulator() {
    this.showSimulation = false;
    this._simulatorService.resetForm();
    this.gtm.sendEventGTM({
      event: 'interaccion',
      eAction: 'reiniciar_simulador',
      eLabel: 'click',
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  requestCustomStudy() {
    this._commonService.openModalLogin(true, false);
    this.userDataService.setIsFromSimulate(true);
  }
}
